import { useId } from "react";

export function Withdraw2Icon({ className }: { className?: string }) {
  const id = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28"
      className={className}
    >
      <path
        fill={`url(#${id})`}
        d="M28 14q0 1.704-.058 3.365c-.203 5.737-4.84 10.374-10.577 10.577Q15.703 28 14 28t-3.365-.058C4.898 27.739.261 23.102.06 17.365a97.84 97.84 0 0 1 0-6.73C.26 4.899 4.899.262 10.637.06Q12.299-.001 14 0q1.704 0 3.365.059C23.102.26 27.74 4.899 27.94 10.636q.06 1.662.06 3.365m-8.553-5.879a1.335 1.335 0 0 0-1.887.073l-7.151 7.717-.472-4.613a1.33 1.33 0 0 0-.422-.844A1.334 1.334 0 0 0 7.28 11.57l.733 7.124c.014.455.205.877.54 1.186.332.308.766.467 1.129.448l7.254.187a1.335 1.335 0 1 0 .07-2.67l-4.636-.117 7.15-7.718a1.337 1.337 0 0 0-.072-1.889"
      />

      <defs>
        <linearGradient id={id} x1="28" x2="0" y1="14" y2="14" gradientUnits="userSpaceOnUse">
          <stop stopColor="#186d27" />
          <stop offset="1" stopColor="#21a038" />
        </linearGradient>
      </defs>
    </svg>
  );
}
